// ======================= Imports =======================
import React, { useRef, useState } from "react";
import "./changeduedate.css";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Toast } from "primereact/toast";
import { api } from "../../../../../../../../../../../utility/AxiosInceptor";
import CommonLoaderBlue from "../../../../../../../../../../components/Loader/LoaderBlue";
import { Calendar } from "primereact/calendar";
import moment from "moment";

// ======================= Main Component =======================
export const ChangeInvoiceDueDate = ({
  setSelectedAction,
  cpData,
  currentInvoice,
  setCurrentActiveDialog,
}) => {
  // ======================= Refs & State =======================
  let toast = useRef();
  const LoginRes = JSON.parse(localStorage.getItem("userData"));
  const [isLoading, setIsLoading] = useState(false);

  // ======================= Validation Schema =======================
  const validationSchema = Yup.object().shape({
    newDueDate: Yup.string().required("Field Is Required"),
  });

  // ======================= Formik Setup =======================
  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      newDueDate: "",
      userId: LoginRes?._id,
      invoiceId: currentInvoice?._id,
    },
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      api
        .patch(`/api/web/invoices/changeInvoiceDueDate`, values)
        .then((res) => {
          setIsLoading(false);
          toast.current.show({
            severity: "success",
            summary: "Invoice Due Date ",
            detail: "Invoice Due Date Updated Successfully",
          });
          setTimeout(() => {
            setSelectedAction("");
            setCurrentActiveDialog({
              void: false,
              lateFee: false,
              adjustInvoice: false,
              paidExternally: false,
              download: false,
              sendEmail: false,
              changeDueDate: false,
            });
          }, 1000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Invoice Due Date ",
            detail:
              err?.response?.data?.message ||
              err?.response?.data?.msg ||
              "Invoice Due Date Updation Failed",
          });
        });
    },
  });

  // ======================= Render =======================
  return (
    <>
      {/* ======================= Overlay ======================= */}
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>

      {/* ======================= Change Due Date Form ======================= */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        id="changeduedate-container"
        className="changeduedate-container flex flex-wrap flex-row justify-content-center"
      >
        <div className="main-void-invoice">
          {/* ======================= Header ======================= */}
          <div className="header-main-container-voidinvoice">
            <div className="header-main-void-invoice">
              <h1>Change Invoice Due Date:</h1>
              <p>
                Update the due date for this invoice. Once submitted, the new
                due date will be applied.
              </p>
            </div>
            <div className="header-bottom-void">
              <p>
                Invoice No<span>{currentInvoice.invoiceNo || "NIL"}</span>
              </p>
              {/* ======================= Due Date Field ======================= */}
              <div className="void-reason-container ">
                <div className="flex flex-wrap w-full flex-row justify-content-between">
                  <label>Due Date:</label>
                  {formik.touched.newDueDate && formik.errors.newDueDate && (
                    <label>{formik.errors.newDueDate}</label>
                  )}
                </div>
                <Calendar
                  onChange={(e) => {
                    // Format date to MM-DD-YYYY
                    const formattedDate = moment(e.value).format("MM-DD-YYYY");
                    // Set Formik value
                    formik.setFieldValue("newDueDate", formattedDate);
                  }}
                  name="newDueDate"
                  className={`${formik.touched.newDueDate && formik.errors.newDueDate && "p-invalid"}`}
                  placeholder="Select Due Date"
                />
              </div>
            </div>
          </div>
          {/* ======================= Action Buttons ======================= */}
          <div className="action-buttons flex flex-wrap flex-row justify-content-between aligbn-item-center">
            <Button
              disabled={isLoading}
              onClick={() => {
                setSelectedAction("");
                setCurrentActiveDialog({
                  void: false,
                  lateFee: false,
                  adjustInvoice: false,
                  download: false,
                });
              }}
              label="Cancel"
            />
            <Button
              type="submit"
              label={
                isLoading ? (
                  <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                    <CommonLoaderBlue sizehere="12" color="white" />{" "}
                  </div>
                ) : (
                  "Submit"
                )
              }
            />
          </div>
        </div>
        {/* ======================= Toast Notification ======================= */}
        <Toast ref={toast} />
      </form>
    </>
  );
};
